<template lang="pug">
  Sidebar

    div.d-flex.justify-content-end.align-items-center.custom-sidebar
      SidebarHeader.flex-fill
        template
          div.d-flex.justify-content-end
            div.p-1.align-self-center.flex-fill.text-left
              span {{ $store.getters.displayName }}
            b-link.align-self-center(to="/system/setting" v-b-tooltip.hover :title="$t('ui.settings')").mr-1
              i.p-1.fa.fa-sliders-h
            b-link.align-self-center(to="/logout" v-b-tooltip.hover :title="$t('ui.logout')")
              i.p-1.fa.fa-sign-out-alt
      SidebarMinimizer(@cui-sidebar-minimize="handleMinimized")
    SidebarNav(:navItems="navItems")
    //- SidebarMinimizer(@cui-sidebar-minimize="handleMinimized")
</template>

<script>
import config from "@/config";
import { Sidebar, SidebarHeader, SidebarNav, SidebarMinimizer } from "@/library/coreui";
import errorTags from "@/errorTags";

export default {
  components: {
    Sidebar,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    errorTags
  },
  data() {
    return {
      timerId: null,
      refreshTime: 60,
      subDetail: null,
      affTotalRow: 0,
      tixTotalRow: 0,
      feedback: {
        success: false,
        status: errorTags.request.failed
      },
    };
  },
  computed: {
    navItems() {
      return [
        {
          name: this.$t("ui.dashboard"),
          icon: "nav-icon cui-dashboard",
          url: "/system/dashboard",
          pages: [config.accessRoles.dashboard]
        },
        {
          name: this.$t("ui.account"),
          icon: "fa fa-users",
          pages: [config.accessRoles.operator, config.accessRoles.memberlist, config.accessRoles.memberdetails, config.accessRoles.socialaccount],
          children: [
            {
              name: this.$tc("ui.operators", 1),
              url: "/account/operator",
              icon: "fa fa-users",
              pages: [config.accessRoles.operator],
            },
            {
              name: this.$tc("ui.member_list"),
              url: "/account/memberList",
              icon: "fa fa-users",
              pages: [config.accessRoles.memberlist]
            },
            {
              name: this.$tc("ui.member_details"),
              url: "/account/memberDetails",
              icon: "fa fa-user",
              pages: [config.accessRoles.memberdetails]
            },
            {
              name: this.$t("ui.social_account"),
              url: "/account/socialaccount",
              icon: "far fa-address-card",
              pages: [config.accessRoles.socialaccount]
            },
            {
              name: this.$t("ui.sub_account"),
              url: "/account/subaccount",
              icon: "fa fa-users",
              pages: [config.accessRoles.subaccount]
            }
          ]
        },
        {
          name: this.$tc("ui.tickets", 1),
          icon: "fas fa-list-alt",
          pages: [config.accessRoles.ticketlist, config.accessRoles.pendingticket],
          children: [
            {
              name: this.$t("ui.ticket_list"),
              url: "/ticket/ticketList",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.ticketlist],
            },
            {
              name: this.$t("ui.pending_ticket"),
              url: "/ticket/pendingTicket",
              icon: "fas fa-list-alt",
              pages: [config.accessRoles.pendingticket],
            }
          ]
        },
        // {
        //   name: this.$tc("ui.tickets", 1),
        //   icon: "fas fa-list-alt",
        //   url: "/ticket",
        //   pages: [config.accessRoles.ticket],
        // },
        {
          name: this.$tc("ui.banks", 1),
          icon: "fas fa-landmark",
          pages: [config.accessRoles.bankgroup, config.accessRoles.bankoperator, config.accessRoles.bankmember],
          children: [
            {
              name: this.$t("ui.bank_group"),
              url: "/bank/bankGroup",
              icon: "fas fa-landmark",
              pages: [config.accessRoles.bankgroup],
            },
            {
              name: this.$t("ui.bank_operator"),
              url: "/bank/bankOperator",
              icon: "fas fa-landmark",
              pages: [config.accessRoles.bankoperator],
            },
            {
              name: this.$t("ui.bank_member"),
              url: "/bank/bankMember",
              icon: "fas fa-landmark",
              pages: [config.accessRoles.bankmember]
            }
          ]
        },
        {
          name: this.$t("ui.promotion"),
          icon: "fas fa-gift",
          pages: [config.accessRoles.promogroup, config.accessRoles.promoaccount, config.accessRoles.promomember, config.accessRoles.promosignup,
                  config.accessRoles.membermission, config.accessRoles.membermissionsummary, config.accessRoles.campaign],
          children: [
            {
              name: this.$t("ui.promotion_group"),
              url: "/promotion/promoGroup",
              icon: "fas fa-list",
              pages: [config.accessRoles.promogroup],
            },
            {
              name: this.$t("ui.promotion"),
              url: "/promotion/promoAccount",
              icon: "fas fa-list",
              pages: [config.accessRoles.promoaccount]
            },
            {
              name: this.$t("ui.promotion_member"),
              url: "/promotion/promoMember",
              icon: "fas fa-list",
              pages: [config.accessRoles.promomember]
            },
            {
              name: this.$t("ui.promotion_signup"),
              url: "/promotion/promoSignup",
              icon: "fas fa-list",
              pages: [config.accessRoles.promosignup]
            },
            {
              name: this.$t("ui.member_mission"),
              url: "/promotion/memberMission",
              icon: "fas fa-list",
              pages: [config.accessRoles.membermission]
            },
            {
              name: this.$t("ui.member_mission_summary"),
              url: "/promotion/memberMissionSummary",
              icon: "fas fa-list",
              pages: [config.accessRoles.membermissionsummary]
            },
            // {
            //   name: this.$t("ui.coupon"),
            //   url: "/promotion/coupon",
            //   icon: "fa fa-tags",
            //   pages: [config.accessRoles.coupon]
            // },
            {
              name: this.$t("ui.campaign"),
              url: "/promotion/campaign",
              icon: "fa fa-tags",
              pages: [config.accessRoles.campaign]
            }
          ]
        },
        {
          name: this.$t("ui.settings"),
          icon: "fa fa-cog",
          pages: [config.accessRoles.providermaintenance, config.accessRoles.providerbetlimit, config.accessRoles.providergameoff,
                  config.accessRoles.providerrtp, config.accessRoles.withdrawallimit, config.accessRoles.globalsetting, config.accessRoles.exchangerate,
                  config.accessRoles.logrepulling],
          children: [
            {
              name: this.$t("ui.provider_maintenance"),
              url: "/setup/providerMaintenance",
              icon: "fa fa-cog",
              pages: [config.accessRoles.providermaintenance],
            },
            {
              name: this.$t("ui.provider_bet_limit"),
              url: "/setup/providerBetLimit",
              icon: "fa fa-cog",
              pages: [config.accessRoles.providerbetlimit],
            },
            {
              name: this.$t("ui.provider_game_off"),
              url: "/setup/providerGameOff",
              icon: "fa fa-cog",
              pages: [config.accessRoles.providergameoff],
            },
            {
              name: this.$t("ui.provider_rtp"),
              url: "/setup/providerRtp",
              icon: "fa fa-cog",
              pages: [config.accessRoles.providerrtp],
            },
            {
              name: this.$t("ui.withdrawal_limit"),
              url: "/setup/withdrawalLimit",
              icon: "fa fa-cog",
              pages: [config.accessRoles.withdrawallimit],
            },
            {
              name: this.$t("ui.global_setting"),
              url: "/setup/globalSetting",
              icon: "fa fa-cog",
              pages: [config.accessRoles.globalsetting],
            },
            {
              name: this.$t("ui.exchange_rate"),
              url: "/setup/exchangeRate",
              icon: "fa fa-cog",
              pages: [config.accessRoles.exchangerate],
            },
            {
              name: this.$t("ui.log_repulling"),
              url: "/setup/logRepulling",
              icon: "fa fa-cog",
              pages: [config.accessRoles.logrepulling],
            },
          ]
        },
        {
          name: this.$t("ui.vip"),
          icon: "fas fa-crown",
          url: "/vip",
          pages: [config.accessRoles.vip],
        },
        {
          name: this.$tc("ui.review", 1),
          icon: "fas fa-comments",
          pages: [config.accessRoles.review],
          children: [
            {
              name: this.$t("ui.review_list"),
              url: "/review/reviewlist",
              icon: "fas fa-comments",
              pages: [config.accessRoles.review],
            },
            {
              name: this.$t("ui.monthly_rating"),
              url: "/review/monthlyrating",
              icon: "fas fa-star",
              pages: [config.accessRoles.review],
            },
            {
              name: this.$t("ui.survey_list"),
              url: "/review/surveyList",
              icon: "fas fa-comments",
              pages: [config.accessRoles.review],
            },
          ]
        },
        {
          name: this.$t("ui.cms"),
          icon: "fa fa-newspaper",
          pages: [config.accessRoles.cms],
          children: [
            {
              name: this.$t("ui.announcement_banner"),
              url: "/cms/announcementBanner",
              icon: "fas fa-list",
              pages: [config.accessRoles.cms],
            },
            {
              name: this.$t("ui.promotion_banner"),
              url: "/cms/promotionBanner",
              icon: "fas fa-list",
              pages: [config.accessRoles.cms]
            },
            {
              name: this.$t("ui.slide_banner"),
              url: "/cms/slideBanner",
              icon: "fas fa-list",
              pages: [config.accessRoles.cms]
            },
            {
              name: this.$t("ui.seo_page"),
              url: "/cms/seoPage",
              icon: "fas fa-list",
              pages: [config.accessRoles.cms]
            },
            {
              name: this.$t("ui.news"),
              url: "/cms/news",
              icon: "fas fa-list",
              pages: [config.accessRoles.cms]
            },
          ]
        },
        // {
        //   name: this.$t("ui.mini_game"),
        //   icon: "fa fa-gamepad",
        //   pages: [config.accessRoles.minigame],
        //   children: [
        //     {
        //       name: this.$t("ui.team"),
        //       url: "/minigame/teamList",
        //       icon: "fa fa-list",
        //       pages: [config.accessRoles.teamlist],
        //     },
        //     {
        //       name: this.$t("ui.match"),
        //       url: "/minigame/matchList",
        //       icon: "fa fa-list",
        //       pages: [config.accessRoles.matchlist],
        //     },
        //     {
        //       name: this.$t("ui.team_log"),
        //       url: "/minigame/matchTeamLog",
        //       icon: "fa fa-file",
        //       pages: [config.accessRoles.matchteamlog],
        //     },
        //     {
        //       name: this.$t("ui.result_log"),
        //       url: "/minigame/matchResultLog",
        //       icon: "fa fa-file",
        //       pages: [config.accessRoles.matchresultlog],
        //     },
        //   ]
        // },
        {
          name: this.$t("ui.log"),
          icon: "fa fa-search",
          pages: [config.accessRoles.adjustmemberlog, config.accessRoles.issuebonuslog, config.accessRoles.gameresultchangeslog],
          children: [
            {
              name: this.$t("ui.adjustment_log"),
              url: "/log/adjustMemberLog",
              icon: "fa fa-file",
              pages: [config.accessRoles.adjustmemberlog],
            },
            {
              name: this.$t("ui.bonus_log"),
              url: "/log/issueBonusLog",
              icon: "fa fa-file",
              pages: [config.accessRoles.issuebonuslog],
            },
            {
              name: this.$t("ui.result_changes_log"),
              url: "/log/gameResultChangesLog",
              icon: "fa fa-file",
              pages: [config.accessRoles.gameresultchangeslog],
            },
            {
              name: this.$t("ui.freespin_log"),
              url: "/log/freespinlog",
              icon: "fa fa-file",
              pages: [config.accessRoles.freespinlog],
            },
          ]
        },
        {
          name: this.$tc("ui.affiliate", 1),
          icon: "fas fa-user-tie",
          pages: [config.accessRoles.affiliate],
          badge: this.totalBadge,
          children: [
            {
              name: this.$t("ui.affiliate_list"),
              url: "/affiliate/affiliatelist",
              icon: "fas fa-user-tie",
              pages: [config.accessRoles.affiliate],
            },
            {
              name: this.$t("ui.player_list"),
              url: "/affiliate/playerlist",
              icon: "fas fa-user",
              pages: [config.accessRoles.affiliate],
            },
            {
              name: this.$t("ui.pending_application"),
              url: "/affiliate/approveaffiliate",
              icon: "fas fa-check-square",
              badge: this.affBadge,
              pages: [config.accessRoles.affiliate],
            },
            {
              name: this.$t("ui.bank_affiliate"),
              url: "/affiliate/bankaffiliate",
              icon: "fas fa-landmark",
              pages: [config.accessRoles.affiliate],
            },
            {
              name: this.$t("ui.withdrawal_request"),
              url: "/affiliate/ticketaffiliate",
              icon: "fas fa-list-alt",
              badge: this.tixBadge,
              pages: [config.accessRoles.affiliate],
            },
            {
              name: this.$t("ui.earning_breakdown"),
              url: "/affiliate/settlementListAffiliate",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.affiliate],
            },
            {
              name: this.$t("ui.daily_winlose_affiliate"),
              url: "/affiliate/dailyWinLoseAffiliate",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.affiliate],
            },
            {
              name: this.$t("ui.daily_winlose_member"),
              url: "/affiliate/dailyWinLoseMemberAffiliate",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.affiliate],
            },
            {
              name: this.$t("ui.comm_log"),
              url: "/affiliate/commUpdateLogAffiliate",
              icon: "fa fa-file",
              pages: [config.accessRoles.affiliate],
            },
          ]
        },
        {
          name: this.$t("ui.report"),
          icon: "fa fa-chart-line",
          pages: [config.accessRoles.dailystatement, config.accessRoles.dailywinlose, config.accessRoles.platformwinlose,
                  config.accessRoles.providerwinlosecompany, config.accessRoles.dailysummarycompany, config.accessRoles.dailysummarymember,
                  config.accessRoles.bankstatement, config.accessRoles.bankstatementdaily, config.accessRoles.onetimedepositor, config.accessRoles.currentmonthnondepositor,
                  config.accessRoles.currentmonthnologin, config.accessRoles.refereelist, config.accessRoles.depositedmember, config.accessRoles.depositedmembercny,
                  config.accessRoles.registeredmember, config.accessRoles.firstdeposit, config.accessRoles.memberexport, config.accessRoles.utmlist, config.accessRoles.ticketexport],
          children: [
            {
              name: this.$t("ui.daily_statement"),
              url: "/report/dailyStatement",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailystatement]
            },
            {
              name: this.$t("ui.daily_winlose"),
              url: "/report/dailyWinLose",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailywinlose]
            },
            {
              name: this.$t("ui.platform_winlose"),
              url: "/report/platformWinLose",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.platformwinlose]
            },
            {
              name: this.$t("ui.provider_winlose_company"),
              url: "/report/providerWinLoseCompany",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.providerwinlosecompany]
            },
            {
              name: this.$t("ui.daily_summary_company"),
              url: "/report/dailySummaryCompany",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailysummarycompany]
            },
            {
              name: this.$t("ui.daily_summary_member"),
              url: "/report/dailySummaryMember",
              icon: "fa fa-chart-line",
              pages: [config.accessRoles.dailysummarymember]
            },
            {
              name: this.$t("ui.bank_statement"),
              url: "/report/bankStatement",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.bankstatement]
            },
            {
              name: this.$t("ui.bank_statement_daily"),
              url: "/report/bankStatementDaily",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.bankstatementdaily]
            },
            {
              name: this.$t("ui.one_time_depositor"),
              url: "/report/oneTimeDepositor",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.onetimedepositor]
            },
            {
              name: this.$t("ui.current_month_non_depositor"),
              url: "/report/currentMonthNonDepositor",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.currentmonthnondepositor]
            },
            {
              name: this.$t("ui.current_month_no_login"),
              url: "/report/currentMonthNoLogin",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.currentmonthnologin]
            },
            {
              name: this.$t("ui.referee_list"),
              url: "/report/refereeList",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.refereelist]
            },
            {
              name: this.$t("ui.deposited_member"),
              url: "/report/depositedMember",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.depositedmember]
            },
            {
              name: this.$t("ui.deposited_member_cny"),
              url: "/report/depositedMemberCNY",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.depositedmembercny]
            },
            {
              name: this.$t("ui.registered_member"),
              url: "/report/registeredMember",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.registeredmember]
            },
            {
              name: this.$t("ui.first_deposit"),
              url: "/report/firstDeposit",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.firstdeposit]
            },
            {
              name: this.$t("ui.members_export"),
              url: "/report/memberExport",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.memberexport]
            },
            {
              name: this.$t("ui.ticket_export"),
              url: "/report/ticketExport",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.ticketexport]
            },
            {
              name: this.$t("ui.utm_list"),
              url: "/report/utmList",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.utmlist]
            },
            {
              name: this.$t("ui.mini_game_prize_report"),
              url: "/report/miniGamePrizeReport",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.minigameprizereport]
            },
          ]
        },
        {
          name: this.$t("ui.report_promotion"),
          icon: "fa fa-chart-line",
          pages: [config.accessRoles.promotionsummary, config.accessRoles.promotionsignupunusedlist, config.accessRoles.promotionsignupongoing,
                  config.accessRoles.promotionwithdrawalsummary],
          children: [
            {
              name: this.$t("ui.promotion_summary"),
              url: "/report/promotionSummary",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionsummary]
            },
            {
              name: this.$t("ui.promotion_withdrawal_summary"),
              url: "/report/promotionWithdrawalSummary",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionwithdrawalsummary]
            },
            {
              name: this.$t("ui.promotion_signup_unused"),
              url: "/report/promotionSignupUnusedList",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionsignupunusedlist]
            },
            {
              name: this.$t("ui.promotion_signup_ongoing"),
              url: "/report/promotionSignupOngoing",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.promotionsignupongoing]
            },
          ]
        },
        {
          name: this.$t("ui.game_result"),
          icon: "fa fa-chart-line",
          pages: [config.accessRoles.gameresultslots, config.accessRoles.gameresultlivecasino, config.accessRoles.gameresultrebate,
                  config.accessRoles.gameresultsportsbook],
          children: [
            {
              name: this.$t("ui.game_result_slots"),
              url: "/report/gameResultSlots",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.gameresultslots]
            },
            {
              name: this.$t("ui.game_result_livecasino"),
              url: "/report/gameResultLivecasino",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.gameresultlivecasino]
            },
            {
              name: this.$t("ui.game_result_rebate"),
              url: "/report/gameResultRebate",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.gameresultrebate]
            },
            {
              name: this.$t("ui.game_result_sportsbook"),
              url: "/report/gameResultSportsbook",
              icon: "fa fa-poll-h",
              pages: [config.accessRoles.gameresultsportsbook]
            }
          ]
        }
      ];
    },
    getAuthorityRole() {
      if (this.$store.getters.authorityRole)
        return this.$store.getters.authorityRole;

      return '';
    },
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    totalBadge() {
      return { "text": this.affTotalRow + this.tixTotalRow, "variant": "danger" }
    },
    tixBadge() {
      return { "text": this.tixTotalRow, "variant": "danger" }
    },
    affBadge() {
      return { "text": this.affTotalRow, "variant": "danger" }
    },
    showNotification() {
      if (this.getAuthorityRole == 'SUB_PRI') {
        if (this.$store.getters.accountAuthority) {
          if (this.$store.getters.accountAuthority[0].authority_option.includes('affiliate'))
            return true;
          else
            return false;
        } else
          return false;
      } else {
        if (this.$store.getters.accountId == config.superUser)
          return true;
        else
          return false;
      }
    }
  },
  created: function() {
    this.$options.refreshEnabled = true;
  },
  mounted: function() {
    if (this.$store.getters.accountId == config.superUser) {
      this.getInfo();
      this.startCountDownRefresh();
    }
  },
  destroyed: function() {
    if (this.timerId) {
      clearTimeout(this.timerId);
    }
  },
  methods: {
    getInfo() {
      if (this.getAuthorityRole == 'SUB_PRI')
        this.getSubDetail();
    },
    getSubDetail() {
      let url = config.accountSubDetailUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        login_id: this.$store.getters.loginId
      };

      this.$http.post(url, json).then(
        function(response) {
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;
              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.subDetail = response.data.dt.length > 0 ? response.data.dt[0] : null;
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
          }
        },
        function(response) {
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
        }
      );
    },
    getAffiliateList() {
      let url = config.accountListAffiliateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        source_account_id: this.$store.getters.accountId,
        is_pending: true,
        tac_validated: null,
        sort_key: "account_id",
        sort_type: "asc",
        page_number: 1,
        page_size: this.getPageSize,
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.affTotalRow = response.data.dt.length > 0 ? response.data.dt[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getWithdrawalList() {
      let url = config.ticketListAffiliateUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        account_id: this.$store.getters.accountId,
        ticket_status: 0,
        start_date: this.$moment(new Date).format('YYYY-MM-DD'),
        end_date: this.$moment(new Date).format('YYYY-MM-DD'),
        sort_type: "desc",
        page_number: 1,
        page_size: this.getPageSize
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.tixTotalRow = response.data.dt.length > 0 ? response.data.dt[0].totalrows : 0;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    startCountDownRefresh: function() {
      if (this.timerId) {
        clearTimeout(this.timerId);
      }
      if (this.$options.refreshEnabled) {
        if (this.showNotification == true) {
          this.getAffiliateList();
          this.getWithdrawalList();
        }

        this.timerId = setTimeout(() => {
          this.startCountDownRefresh();
        }, this.refreshTime * 1000);
      }
    },
    handleMinimized(e) {
      this.$store.dispatch("layout/setSidebarMinimized", e);
    }
  }
};
</script>

<style lang="scss" scoped>
.custom-sidebar {
  background: rgba(0, 0, 0, 0.4);
  -webkit-box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.2);
  box-shadow: inset 0 0 20px rgba(0, 0, 0, 0.2);
  .sidebar-header {
    background: transparent;
    box-shadow: none;
  }
}
</style>
